import dental_img from "../../Image/proj_imgs/learnersexam.jpg";
import resume_img from "../../Image/proj_imgs/studentresult.jpg";
import login_img from "../../Image/proj_imgs/onlineexam.jpg";
import cv_maker from "../../Image/proj_imgs/cvmaker.jpg";
import html from "../../Image/proj_imgs/htmlgenerator.jpg";
const proj_data = [
  {
    id: 1,
    project_name: "Online HTML Website Generator",
    proj_creation_date: "June 2022",
    project_image: html,
    proj_code_like: "https://github.com/shuvam2722/HTMLwebsitemaker",
    proj_live_link: "https://writy-beta.vercel.app/",
  },
  {
    id: 2,
    project_name: "Student Result Management System",
    proj_creation_date: "Oct 2022",
    project_image: resume_img,
    proj_code_like: "https://drive.google.com/file/d/1X7EHGSAlfJNQh5BndvYB7XmlBJVm7Mwj/view?usp=share_link",
    proj_live_link: "https://learnersresult.000webhostapp.com/",
  },
  {
    id: 3,
    project_name: "Online Assessment Frontend",
    proj_creation_date: "Nov 2022",
    project_image: login_img,
    proj_code_like: "https://drive.google.com/file/d/1C59BI_QD32M9g2GRlvDQtazWJfVsB-wn/view?usp=share_link",
    proj_live_link: "https://learnersexamportal.000webhostapp.com/",
  },
  {
    id: 4,
    project_name: "Online Resume Generator",
    proj_creation_date: "Feb 2022",
    project_image: cv_maker,
    proj_code_like: "https://github.com/shuvam2722/onlineCVmaker",
    proj_live_link: "https://cvmaker-henna.vercel.app/",
  },
  {
    id: 5,
    project_name: "Online Examination Portal",
    proj_creation_date: "Nov 2022",
    project_image: dental_img,
    proj_code_like: "https://github.com/shuvam2722/Learners-Examination-Portal",
    proj_live_link: "https://learnersexamportal.vercel.app/",
  },
  
  {
    id: 6,
    project_name: "Online Food Delivery App",
    proj_creation_date: "",
    project_image: login_img,
    proj_code_like: "",
    proj_live_link: "",
  },
  {
    id: 7,
    project_name: "Banking Management Web App",
    proj_creation_date: "",
    project_image: login_img,
    proj_code_like: "",
    proj_live_link: "",
  },
  {
    id: 8,
    project_name: "",
    proj_creation_date: "Dec 2021",
    project_image: login_img,
    proj_code_like: "",
    proj_live_link: "",
  },
  {
    id: 9,
    project_name: "",
    proj_creation_date: "Dec 2021",
    project_image: login_img,
    proj_code_like: "",
    proj_live_link: "",
  },
];

export default proj_data;
